<?xml version="1.0" encoding="UTF-8"?>
<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>Form Elements/Checkbox/x/check_icon/18</title>
    <desc>Created with Sketch.</desc>
    <g id="Form-Elements/Checkbox/x/check_icon/18" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon id="Path-2" fill="#FFFFFF" fill-rule="nonzero" points="14.2474233 4.34149539 15.7525767 5.65850461 8.04871006 14.4629236 3.29289322 9.70710678 4.70710678 8.29289322 7.951 11.536"></polygon>
    </g>
</svg>